import { Snackbar, Alert } from '@mui/material';

export default function SnackAlert(props) {
  const { setSnackAlert, snackAlert } = props;
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    const snackAlert = { open: false, severity: null, message: null };
    setSnackAlert(snackAlert);
  };
  if (snackAlert) {
    const { open, severity, message } = snackAlert;
    return (
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        key={open}>
        <Alert severity={severity} onClose={handleClose}>
          {message}
        </Alert>
      </Snackbar>
    );
  } else {
    return null;
  }
}